module.exports = __webpack_public_path__ + "static/media/snow.d37fc7cb.jpg";